interface IDetailInfoArea {
    title: string,
    children: React.ReactNode,
    className?: string
    start?: boolean
    isTag?: boolean
}


const DetailInfoArea = ({ title, children, className, start, isTag }: IDetailInfoArea) => {

    return (
        <div className={`flex ${start ? 'items-start' : 'items-center'} tablet:flex-col tablet:items-start`}>
            <div className="w-[150px] text-lg shrink-0">
                {
                    isTag ?
                        <p className='flex items-center gap-2' dangerouslySetInnerHTML={{ __html: title }}></p> :
                        <p>{title}</p>
                }
            </div>
            <div className={`flex items-center min-w-[600px] tablet:min-w-[100%] ${className}`}>
                {children}
            </div>
        </div>
    )
}

export default DetailInfoArea;